import type { AgentTool } from '@saaga/shared/interfaces/agent-tool.interface'
import type { LlmModel } from '@saaga/shared/interfaces/llm-model.interface'
import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { Form } from '@/components/ui/form'
import { ScrollArea } from '@/components/ui/scroll-area'
import { TooltipProvider } from '@/components/ui/tooltip'

import type { AgentNodeFormSchemaType } from './agency-node-form.schema'
import { AgentNodeDrawerFooter } from './agent-node-drawer-footer.atom'
import { AgentNodeDrawerForm } from './agent-node-drawer-form.molecule'
import { AgentNodeDrawerHeader } from './agent-node-drawer-header.atom'

export interface AgentNodeDrawerContentProps {
  form: UseFormReturn<AgentNodeFormSchemaType>
  nodeId: string | null
  isEntryPoint?: boolean
  isMobile: boolean
  modelList: LlmModel[]
  isLoadingModels: boolean
  toolList: AgentTool[]
  isLoadingTools: boolean
  imagePreviewUrl: string | null
  onImageChange: (file: File | null) => void
  onImageRemove: () => void
  onCancel: () => void
  onSubmit: (values: AgentNodeFormSchemaType) => void
}

export const AgentNodeDrawerContent = ({
  form,
  nodeId,
  isEntryPoint,
  isMobile,
  modelList,
  isLoadingModels,
  toolList,
  isLoadingTools,
  imagePreviewUrl,
  onImageChange,
  onImageRemove,
  onCancel,
  onSubmit,
}: AgentNodeDrawerContentProps): ReactNode => (
  <>
    <AgentNodeDrawerHeader isEntryPoint={isEntryPoint} isMobile={isMobile} onCancel={onCancel} />
    <ScrollArea className="agent-node-drawer-scroll min-h-0 flex-1 [&>[data-slot=scroll-area-viewport]]:h-full">
      <TooltipProvider>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <AgentNodeDrawerForm
              form={form}
              nodeId={nodeId}
              modelList={modelList}
              isLoadingModels={isLoadingModels}
              toolList={toolList}
              isLoadingTools={isLoadingTools}
              imagePreviewUrl={imagePreviewUrl}
              onImageChange={onImageChange}
              onImageRemove={onImageRemove}
            />
          </form>
        </Form>
      </TooltipProvider>
    </ScrollArea>
    <AgentNodeDrawerFooter onCancel={onCancel} onSubmit={form.handleSubmit(onSubmit)} />
  </>
)

AgentNodeDrawerContent.displayName = 'AgentNodeDrawerContent'
